import { capitalizeArrayOfString } from './capitalizeArrayOfString';

export const StringUtil = { capitalizeArrayOfString };
